import React from 'react';
import { observer } from 'mobx-react-lite';
import DynamicFormModalDEPRECATED from 'components/common/modals/DynamicFormModal_DEPRECATED';
import EditPrimaryModalStore from 'store/ui-stores/elections/editPrimaryModalStore';
import { createEditPrimaryModalStyles } from './styles';

interface Props {
  modalStore: EditPrimaryModalStore;
  isEditable: boolean;
  onAction: (e: React.FormEvent) => void;
}

const EditPrimaryModal = observer(({ modalStore, isEditable, onAction }: Props): JSX.Element => {
  const classes = createEditPrimaryModalStyles();
  const { loading, dynamicForm, form, isEditPrimaryModalOpen, closeEditPrimaryModal } = modalStore;

  return (
    <DynamicFormModalDEPRECATED
      show={isEditPrimaryModalOpen}
      onClose={closeEditPrimaryModal}
      onAction={onAction}
      dynamicForm={dynamicForm}
      form={form}
      loading={loading}
      isEditable={isEditable}
      className={classes.modal}
    />
  );
});

export default EditPrimaryModal;
